import { c as _c } from "react/compiler-runtime";
import { ButtonStyle } from '@sola/ark-core/atoms/button-style/button-style.tsx';
import { Link } from '@sola/ark-core/atoms/link/link.tsx';
import { Pictogram } from '@sola/ark-core/atoms/pictogram/pictogram.tsx';
import { getDeparturePath, knownMyUrls } from '@sola/my-sdk/constants.ts';
import type { GraphQLCommitmentParticipant } from '@sola/schema/dotcom/supporters/schema.generated.ts';
import { PrimaryCta, PrimaryCtaActions, PrimaryCtaBody, PrimaryCtaHeading, PrimaryCtaIcon, PrimaryCtaText } from '../primary-cta/primary-cta.tsx';
import { usePrimaryCtaDeparture } from './primary-cta-departure.logic.ts';
export type PrimaryCtaDepartureProps = {
  participants: GraphQLCommitmentParticipant[];
};
const defaultParticipants: GraphQLCommitmentParticipant[] = [];
export const PrimaryCtaDeparture: React.FC<PrimaryCtaDepartureProps> = t0 => {
  const $ = _c(18);
  const {
    participants: t1
  } = t0;
  const participants = t1 === undefined ? defaultParticipants : t1;
  let t2;
  if ($[0] !== participants) {
    t2 = {
      participants
    };
    $[0] = participants;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    title,
    subtitle,
    cta
  } = usePrimaryCtaDeparture(t2);
  if (!participants || participants.length === 0) {
    return null;
  }
  let learnMoreHref = knownMyUrls.sponsorshipsBase;
  if (participants.length === 1 && participants[0]?.globalId) {
    const t3 = participants[0]?.globalId;
    let t4;
    if ($[2] !== t3) {
      t4 = getDeparturePath(t3);
      $[2] = t3;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    learnMoreHref = t4;
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PrimaryCtaIcon><Pictogram name="exit" /></PrimaryCtaIcon>;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== title) {
    t4 = <PrimaryCtaHeading>{title}</PrimaryCtaHeading>;
    $[5] = title;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== subtitle) {
    t5 = <PrimaryCtaText>{subtitle}</PrimaryCtaText>;
    $[7] = subtitle;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <PrimaryCtaBody>{t4}{t5}</PrimaryCtaBody>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== cta || $[13] !== learnMoreHref) {
    t7 = <PrimaryCtaActions><ButtonStyle variant="secondary"><Link href={learnMoreHref}>{cta}</Link></ButtonStyle></PrimaryCtaActions>;
    $[12] = cta;
    $[13] = learnMoreHref;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== t6 || $[16] !== t7) {
    t8 = <PrimaryCta variant="default">{t3}{t6}{t7}</PrimaryCta>;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  return t8;
};